import { PatchGraphneQueuesQueueidPropertiesRequest, useGraphneAPI } from '@nexelem/graphne-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useProductionQueuePropertiesMutation = () => {
  const api = useGraphneAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PatchGraphneQueuesQueueidPropertiesRequest) => api.patchGraphneQueuesQueueidProperties(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['production-queues'] });
    },
  });
};
